import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PasswordReset.scss';

const PasswordReset = () => {
  const { token: urlToken } = useParams(); // Token aus der URL
  const navigate = useNavigate(); // Für Weiterleitung
  const [step, setStep] = useState(1); // 1 = Mail anfordern, 2 = Passwort zurücksetzen
  const [benutzername, setBenutzername] = useState('');
  const [neuesPasswort, setNeuesPasswort] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  // Wenn Token in URL vorhanden → automatisch Schritt 2
  useEffect(() => {
    if (urlToken) setStep(2);
  }, [urlToken]);

  // Schritt 1: Reset-Mail anfordern
  const handleRequestReset = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!benutzername) {
      setError('Bitte Benutzername eingeben.');
      return;
    }

    try {
      await axios.post(
        'https://jugehoerig-backend.onrender.com/api/password-reset/request',
        { benutzername }
      );
      setMessage('Reset-Mail wurde versendet. Bitte überprüfe dein Postfach.');
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Anfordern des Resets.');
    }
  };

  // Schritt 2: Passwort zurücksetzen
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!neuesPasswort || !confirmPassword) {
      setError('Bitte alle Felder ausfüllen.');
      return;
    }

    if (neuesPasswort !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    try {
      await axios.put(
        'https://jugehoerig-backend.onrender.com/api/password-reset/reset',
        { token: urlToken, neuesPasswort }
      );
      setMessage('Passwort erfolgreich geändert. Du wirst nun weitergeleitet...');

      // kurze Verzögerung, dann Weiterleitung
      setTimeout(() => {
        navigate('/login');
      }, 1500);

      // Felder zurücksetzen
      setStep(1);
      setBenutzername('');
      setNeuesPasswort('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Zurücksetzen des Passworts.');
    }
  };

  return (
    <div className="password-reset-container">
      {/* Step 1: Mail anfordern */}
      {step === 1 && (
        <form className="password-reset-form" onSubmit={handleRequestReset}>
          <h2 className="title">Passwort vergessen</h2>
          <div className="form-group">
            <label htmlFor="benutzername">Benutzername</label>
            <input
              type="text"
              id="benutzername"
              value={benutzername}
              onChange={(e) => setBenutzername(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          <button type="submit" className="submit-button">
            Reset-Mail senden
          </button>
        </form>
      )}

      {/* Step 2: Passwort zurücksetzen */}
      {step === 2 && (
        <form className="password-reset-form" onSubmit={handleResetPassword}>
          <h2 className="title">Neues Passwort setzen</h2>
          <div className="form-group">
            <label htmlFor="neuesPasswort">Neues Passwort</label>
            <input
              type="password"
              id="neuesPasswort"
              value={neuesPasswort}
              onChange={(e) => setNeuesPasswort(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Passwort wiederholen</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          <button type="submit" className="submit-button">
            Passwort ändern
          </button>
        </form>
      )}
    </div>
  );
};

export default PasswordReset;
